module.exports = __webpack_public_path__ + "static/media/pores_fullface.0449a4e5.svg";